import routes from '@root/routes';
import { Landlord } from '@root/types';
import { useTranslation } from 'react-i18next';
import { useFlags } from 'launchdarkly-react-client-sdk';
import PageHead from '@components/shared/PageHead/PageHead';

type Props = {
  landlord: Landlord;
};

const getLandlordDescriptionT = (landlord: Landlord): string => {
  const hasMarkets = landlord.marketSlugs && landlord.marketSlugs.length > 0;
  if (hasMarkets) {
    return 'landlord:meta.description.withMarkets';
  }

  return 'landlord:meta.description.withoutMarkets';
};

const marketCity = (flags, t, marketSlug) => {
  const fullMarketName = flags['public-london-market']
    ? t(`common:markets.${marketSlug}`)
    : t(`common:deprecatedMarkets.${marketSlug}`);

  return fullMarketName.split(', ')[0]; // Leave out the country code.
};

const LandlordHead = ({ landlord }: Props) => {
  const { t } = useTranslation();
  const flags = useFlags();

  const marketsList = landlord.marketSlugs
    .map(marketSlug => marketCity(flags, t, marketSlug))
    .join(', ');

  const title = t('landlord:meta.title', { name: landlord.name });
  const description = t(getLandlordDescriptionT(landlord), { name: landlord.name, marketsList });
  const canonicalUrl = routes.landlords(landlord.slug);

  return (
    <PageHead
      title={title}
      description={description}
      canonicalURL={canonicalUrl}
      removeFromSEOIndex={landlord.isDemo}
    />
  );
};

export default LandlordHead;
